import API from "../components/utils/API";

export default class Membership {
    static listMembership = async (id) => {
        return await API.request('v1/transaction/list-memberships?id=' + id, 'GET',null,'e904d3efd4c28382a22f8dc32fb3ae8a');
    }
}